// "How did you find me?" — the one-tap question on the thank-you page.

var sourceText = {
  en: {
    q: 'One last thing — how did you find me?',
    sub: 'One tap. It tells me where to spend my time.',
    thanks: 'Thank you — that really helps.',
    facebook_ad: 'Facebook ad', instagram: 'Instagram', google: 'Google',
    friend: 'A friend', facebook_group: 'Facebook group', youtube: 'YouTube',
    forum: 'forScore / MobileSheets forum', teacher: 'Teacher or school',
    music_store: 'Music store', other: 'Somewhere else'
  },
  es: {
    q: 'Una última cosa: ¿cómo me encontraste?',
    sub: 'Un solo toque. Me dice dónde merece la pena invertir mi tiempo.',
    thanks: 'Gracias, esto ayuda de verdad.',
    facebook_ad: 'Anuncio de Facebook', instagram: 'Instagram', google: 'Google',
    friend: 'Un amigo', facebook_group: 'Grupo de Facebook', youtube: 'YouTube',
    forum: 'Foro de forScore / MobileSheets', teacher: 'Profesor o escuela',
    music_store: 'Tienda de música', other: 'En otro sitio'
  },
  ja: {
    q: '最後に一つ — どこで私を知りましたか？',
    sub: 'タップ一回だけ。今後どこに力を入れるかの参考になります。',
    thanks: 'ありがとうございます。とても助かります。',
    facebook_ad: 'Facebook広告', instagram: 'Instagram', google: 'Google',
    friend: '友人から', facebook_group: 'Facebookグループ', youtube: 'YouTube',
    forum: 'forScore / MobileSheets フォーラム', teacher: '先生・学校',
    music_store: '楽器店', other: 'その他'
  },
  de: {
    q: 'Noch eine Frage — wie hast du mich gefunden?',
    sub: 'Ein Tipp genügt. Er zeigt mir, wo meine Zeit gut investiert ist.',
    thanks: 'Danke, das hilft wirklich.',
    facebook_ad: 'Facebook-Anzeige', instagram: 'Instagram', google: 'Google',
    friend: 'Von Freunden', facebook_group: 'Facebook-Gruppe', youtube: 'YouTube',
    forum: 'forScore- / MobileSheets-Forum', teacher: 'Lehrer oder Schule',
    music_store: 'Musikgeschäft', other: 'Woanders'
  },
  fr: {
    q: 'Une dernière chose — comment m’avez-vous trouvé ?',
    sub: 'Un seul clic. Cela me dit où investir mon temps.',
    thanks: 'Merci, cela m’aide beaucoup.',
    facebook_ad: 'Publicité Facebook', instagram: 'Instagram', google: 'Google',
    friend: 'Un ami', facebook_group: 'Groupe Facebook', youtube: 'YouTube',
    forum: 'Forum forScore / MobileSheets', teacher: 'Professeur ou école',
    music_store: 'Magasin de musique', other: 'Ailleurs'
  },
  it: {
    q: 'Un’ultima cosa — come mi hai trovato?',
    sub: 'Un tocco. Mi dice dove vale la pena investire il mio tempo.',
    thanks: 'Grazie, mi aiuta davvero.',
    facebook_ad: 'Inserzione Facebook', instagram: 'Instagram', google: 'Google',
    friend: 'Un amico', facebook_group: 'Gruppo Facebook', youtube: 'YouTube',
    forum: 'Forum forScore / MobileSheets', teacher: 'Insegnante o scuola',
    music_store: 'Negozio di musica', other: 'Altrove'
  },
  uk: {
    q: 'І останнє — як ви мене знайшли?',
    sub: 'Один дотик. Це підкаже, куди вкладати мій час.',
    thanks: 'Дякую, це справді допомагає.',
    facebook_ad: 'Реклама у Facebook', instagram: 'Instagram', google: 'Google',
    friend: 'Від друга', facebook_group: 'Група у Facebook', youtube: 'YouTube',
    forum: 'Форум forScore / MobileSheets', teacher: 'Викладач або школа',
    music_store: 'Музичний магазин', other: 'Десь інде'
  }
};

export var SOURCE_IDS = ['facebook_ad', 'instagram', 'google', 'friend', 'facebook_group',
  'youtube', 'forum', 'teacher', 'music_store', 'other'];

export default sourceText;
